import React from "react";
import { withStyles } from "@mui/styles";
import { PropTypes } from "prop-types";
import { Tooltip } from "@mui/material";

const StyledToolTip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#EEEEEE",
    padding: "10px 20px",
    maxWidth: 400,
    color: "rgba(0, 0, 0, 0.87)",
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dedede",
  },
}))(Tooltip);

export default function HtmlTooltip({ type, title }) {
  return (
    <StyledToolTip placement="right" title={title} interactive>
      <span className={"type tip"}>{type}</span>
    </StyledToolTip>
  );
}
HtmlTooltip.propTypes = {
  type: PropTypes.string.isRequired,
  title: PropTypes.any.isRequired,
};
